import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorSettlement = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M12 3.75a8.224 8.224 0 0 0-5.958 2.544.75.75 0 0 1-1.084-1.038A9.724 9.724 0 0 1 12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75a9.71 9.71 0 0 1-5.959-2.032.75.75 0 0 1 .918-1.187A8.25 8.25 0 1 0 12 3.75Z"
    />
    <path
      fill="#F7A600"
      d="M8.75 9.4a.75.75 0 0 1-.75.75H3a.75.75 0 1 1 0-1.5h5a.75.75 0 0 1 .75.75ZM7.75 12.4a.75.75 0 0 1-.75.75H2a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 .75.75ZM8 16.15a.75.75 0 0 0 0-1.5H3a.75.75 0 0 0 0 1.5h5Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M16.45 12.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V7.7a.75.75 0 0 1 1.5 0v4.05h2.75a.75.75 0 0 1 .75.75Z"
    />
  </svg>
);
export default SvgTwoColorSettlement;
